import useFetchFromBackend from "../../shared/lib/fetch-from-backed";

export default function useTemplateList(queryParams = {}) {
  const { data, isLoading, error } = useFetchFromBackend({
    path: "/templates",
    params: queryParams,
    queryKey: ["templates", queryParams],
    options: {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  });

  return { data, isLoading, error };
}
